<template>
    <div>
        <AppHeader />
        
        <main class="legal-check-page">
            <div class="container">
                <div class="legal-check-container">
                    <!-- Título -->
                    <div class="legal-header-main">
                        <h1>📋 {{ $t('legal_check.title') }}</h1>
                        <p class="legal-subtitle">{{ $t('legal_check.subtitle') }}</p>
                    </div>

                    <!-- Barra de progreso -->
                    <div class="scroll-progress">
                        <div class="scroll-progress-bar" :style="{ width: progresoScroll + '%' }"></div>
                    </div>

                    <div class="legal-content" ref="legalContent" @scroll="actualizarProgreso">
                        <!-- ============================================ -->
                        <!-- DATOS DE IDENTIFICACIÓN -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.identification') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.identification_text') }}</p>
                                <ul class="legal-list">
                                    <li v-for="item in identificationItems" :key="item.label">
                                        <span class="legal-list-label">{{ item.label }}:</span>
                                        <span class="legal-list-value">{{ item.value }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- TÉRMINOS DE USO Y OBLIGACIONES -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.terms') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.terms_text1') }}</p>
                                <p class="text-justify">{{ $t('legal_check.terms_text2') }}</p>
                                <p class="text-justify">{{ $t('legal_check.terms_text3') }}</p>
                                <p class="text-justify">{{ $t('legal_check.terms_text4') }}</p>
                                <ul class="legal-list">
                                    <li v-for="item in termsList" :key="item">• {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- PROPIEDAD INTELECTUAL E INDUSTRIAL -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.intellectual') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.intellectual_text1') }}</p>
                                <p class="text-justify">{{ $t('legal_check.intellectual_text2') }}</p>
                                <p class="text-justify">{{ $t('legal_check.intellectual_text3') }}</p>
                                <ul class="legal-list">
                                    <li v-for="item in intellectualList" :key="item">• {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- ENLACES -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.links') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.links_text1') }}</p>
                                <p class="text-justify">{{ $t('legal_check.links_text2') }}</p>
                                <p class="text-justify">{{ $t('legal_check.links_text3') }}</p>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- SEGURIDAD DE LA WEB -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.security') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.security_text1') }}</p>
                                <p class="text-justify">{{ $t('legal_check.security_text2') }}</p>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- MODIFICACIÓN UNILATERAL Y DURACIÓN -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.modification') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.modification_text') }}</p>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD -->
                        <!-- ============================================ -->
                        <div class="legal-panel legal-panel-warning">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.exclusion') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.exclusion_intro') }}</p>
                                <ul class="legal-list">
                                    <li v-for="item in exclusionList" :key="item">• {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- TRATAMIENTO DE DATOS PERSONALES -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.data') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.data_text') }}</p>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- LEGISLACIÓN APLICABLE Y JURISDICCIÓN -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.jurisdiction') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify">{{ $t('legal_check.jurisdiction_text') }}</p>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- CONTACTO -->
                        <!-- ============================================ -->
                        <div class="legal-panel">
                            <div class="legal-panel-header">
                                <h2>{{ $t('legal_check.contact') }}</h2>
                            </div>
                            <div class="legal-panel-body">
                                <p class="text-justify" v-html="$t('legal_check.contact_text')"></p>
                            </div>
                        </div>

                        <!-- ============================================ -->
                        <!-- CHECKBOX DE ACEPTACIÓN -->
                        <!-- ============================================ -->
                        <!--<div class="acceptance-section" v-if="!hideDiv">-->
                        <div class="acceptance-section" style="display: none;">
                            <label class="acceptance-checkbox">
                                <input type="checkbox" v-model="acepta" @change="mostrarError = false">
                                <span>
                                    {{ $t('legal_check.accept') }} <strong>{{ $t('legal_check.legal_notice') }}</strong> {{ $t('legal_check.and') }} <strong>{{ $t('legal_check.terms_conditions') }}</strong>.
                                </span>
                            </label>
                            <div v-if="mostrarError" class="acceptance-error">
                                <ion-icon name="alert-circle-outline"></ion-icon>
                                {{ $t('legal_check.accept_error') }}
                            </div>
                        </div>
                    </div>

                    <!-- Botones -->
                    <div class="legal-actions" style="display: none;">
                        <router-link :to="`/${currentLang}/calculadora`" class="btn btn-outline" v-if="!hideDiv">
                            <ion-icon name="arrow-back-outline"></ion-icon> {{ $t('legal_check.back') }}
                        </router-link>
                        <div class="btn-group">
                            <button class="btn btn-secondary" @click="descargarPDF">
                                <ion-icon name="download-outline"></ion-icon> {{ $t('legal_check.download') }}
                            </button>
                            <button class="btn btn-primary" @click="continuar" :disabled="!acepta" v-if="!hideDiv">
                                {{ $t('legal_check.continue') }} <ion-icon name="arrow-forward-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <AppFooter />
        <WhatsAppFloat />
    </div>
</template>

<script>
import AppHeader from '@/components/layout/Header.vue'
import AppFooter from '@/components/layout/Footer.vue'
import WhatsAppFloat from '@/components/common/WhatsAppFloat.vue'
import { jsPDF } from 'jspdf'
import { API_URL } from '@/config'

export default {
    name: 'AvisoLegalCheck',
    components: {
        AppHeader,
        AppFooter,
        WhatsAppFloat
    },
    data() {
        return {
            acepta: false,
            mostrarError: false,
            progresoScroll: 0,
            hideDiv: false
        }
    },
    mounted() {
        // ✅ Verificar si viene de success.html con pago completado
        const urlParams = new URLSearchParams(window.location.search)
        const info = urlParams.get('info')
        
        if (info === 'true') {
            this.hideDiv = true
        }
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        },
        identificationItems() {
            return [
                { label: this.$t('legal_check.company_name'), value: 'UNIT SEGUROS MEDIACION, S.L.' },
                { label: this.$t('legal_check.address'), value: 'JUAN DE LA CIERVA, LOCAL 4, PARCELA 19-24, SAN GINES, 30169, Murcia' },
                { label: this.$t('legal_check.email'), value: 'info@unitseguros.com' },
                { label: this.$t('legal_check.cif'), value: 'B73066557' },
                { label: this.$t('legal_check.registry'), value: this.$t('legal_check.registry_data') },
                { label: this.$t('legal_check.representative'), value: 'Alfonso García Sánchez' }
            ]
        },
        termsList() {
            return [
                this.$t('legal_check.terms_list1'),
                this.$t('legal_check.terms_list2'),
                this.$t('legal_check.terms_list3')
            ]
        },
        intellectualList() {
            return [
                this.$t('legal_check.intellectual_list1'),
                this.$t('legal_check.intellectual_list2'),
                this.$t('legal_check.intellectual_list3')
            ]
        },
        exclusionList() {
            return [
                this.$t('legal_check.exclusion_list1'),
                this.$t('legal_check.exclusion_list2'),
                this.$t('legal_check.exclusion_list3')
            ]
        }
    },
    methods: {
        actualizarProgreso() {
            const el = this.$refs.legalContent
            if (el) {
                const scroll = el.scrollTop
                const height = el.scrollHeight - el.clientHeight
                this.progresoScroll = height > 0 ? Math.round((scroll / height) * 100) : 0
            }
        },
        continuar() {
            if (!this.acepta) {
                this.mostrarError = true
                return
            }
            this.mostrarError = false
            localStorage.setItem('aviso_legal_aceptado', 'true')
            
            // ✅ Ir directamente a Stripe (pasarela de pago)
            //this.irAPasarelaPago()
        },
        /*async irAPasarelaPago() {
            try {
                // Recuperar datos del localStorage (desde la calculadora)
                let formData = {}
                const rawData = localStorage.getItem('expat_form_data')
                if (rawData) {
                    formData = JSON.parse(rawData)
                }
                
                // Validar que tenemos los datos necesarios
                if (!formData.nombre || !formData.email || !formData.documento) {
                    alert('Faltan datos del cliente. Por favor, vuelve a la calculadora.')
                    this.$router.push({ name: 'calculadora', params: { lang: this.currentLang } })
                    return
                }
                
                // Calcular el importe mensual
                const monthlyAmount = formData.amount || 46
                const baseAmountEUR = formData.baseAmountEUR || monthlyAmount
                
                // Obtener fecha de contratación
                const fechaContratacion = new Date().toISOString()

                //console.log("aaaaa " + `${API_URL}/com.api.create-checkout.php`)
                
                // Llamar a Stripe
                const response = await fetch(`${API_URL}/com.api.create-checkout.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        amount: monthlyAmount,
                        baseAmountEUR: baseAmountEUR,
                        currency: formData.currency || 'EUR',
                        customerEmail: formData.email,
                        customerName: `${formData.nombre} ${formData.apellidos || ''}`,
                        policyType: "Salud Completa (Pago Anual)",
                        fecha_contratacion: fechaContratacion
                    })
                })
                
                const result = await response.json()
                
                if (result.url) {
                    // ✅ Redirigir a Stripe
                    window.location.href = result.url
                } else {
                    throw new Error(result.error || 'Error al crear sesión de pago')
                }
                
            } catch (error) {
                console.error('Error:', error)
                alert('Error al procesar el pago: ' + error.message)
            }
        },*/
        descargarPDF() {
            const doc = new jsPDF({
                    orientation: 'portrait',
                    unit: 'mm',
                    format: 'a4',
                    compress: true
                })
            const fullDate = new Date().toLocaleDateString('es-ES')
            
            doc.setFontSize(18)
            doc.setFont('helvetica', 'bold')
            doc.text('Aviso Legal', 105, 20, { align: 'center' })
            
            doc.setFontSize(11)
            doc.setFont('helvetica', 'normal')
            doc.text('UNIT SEGUROS MEDIACION, S.L.', 105, 30, { align: 'center' })
            
            let y = 45
            const lineHeight = 6
            const maxWidth = 175
            
            const addText = (text, indent = 0, fontSize = 9, isBold = false) => {
                if (y > 270) { doc.addPage(); y = 20 }
                doc.setFontSize(fontSize)
                doc.setFont('helvetica', isBold ? 'bold' : 'normal')
                const lines = doc.splitTextToSize(text, maxWidth - indent)
                doc.text(lines, 15 + indent, y)
                y += lines.length * lineHeight + 2
            }
            
            const addList = (items, indent = 5) => {
                items.forEach(item => {
                    if (y > 270) { doc.addPage(); y = 20 }
                    doc.setFontSize(9)
                    doc.setFont('helvetica', 'normal')
                    const lines = doc.splitTextToSize(item, maxWidth - indent - 5)
                    doc.text(lines, 15 + indent, y)
                    y += lines.length * lineHeight + 1
                })
                y += 3
            }
            
            const addSection = (title, content, isList = false, items = []) => {
                if (y > 270) { doc.addPage(); y = 20 }
                doc.setFontSize(12)
                doc.setFont('helvetica', 'bold')
                doc.text(title, 15, y)
                y += 8
                if (isList) {
                    addList(items)
                } else {
                    if (y > 270) { doc.addPage(); y = 20 }
                    doc.setFontSize(9)
                    doc.setFont('helvetica', 'normal')
                    const lines = doc.splitTextToSize(content, maxWidth)
                    doc.text(lines, 15, y)
                    y += lines.length * lineHeight + 3
                }
                y += 2
            }
            
            // Generar PDF
            addSection('DATOS DE IDENTIFICACIÓN', this.$t('legal_check.identification_text'))
            addList([
                '• Nombre de la empresa: UNIT SEGUROS MEDIACION, S.L.',
                '• Dirección: JUAN DE LA CIERVA, LOCAL 4, PARCELA 19-24, SAN GINES, 30169, Murcia',
                '• Correo Electrónico: info@unitseguros.com',
                '• CIF: B73066557',
                '• Datos Registrales: Registro Mercantil de Murcia, Tomo 1639 -- Libro 0 -- Folio 44 -- Sección 8 -- Hoja MU31021 -- Inscripción 1',
                '• Representante legal: Alfonso García Sánchez'
            ])
            
            addSection('TÉRMINOS DE USO Y OBLIGACIONES DE LOS USUARIOS', this.$t('legal_check.terms_text1'))
            addText(this.$t('legal_check.terms_text2'))
            addText(this.$t('legal_check.terms_text3'))
            addText(this.$t('legal_check.terms_text4'))
            addList([
                '• ' + this.$t('legal_check.terms_list1'),
                '• ' + this.$t('legal_check.terms_list2'),
                '• ' + this.$t('legal_check.terms_list3')
            ])
            
            addSection('PROPIEDAD INTELECTUAL E INDUSTRIAL', this.$t('legal_check.intellectual_text1'))
            addText(this.$t('legal_check.intellectual_text2'))
            addText(this.$t('legal_check.intellectual_text3'))
            addList([
                '• ' + this.$t('legal_check.intellectual_list1'),
                '• ' + this.$t('legal_check.intellectual_list2'),
                '• ' + this.$t('legal_check.intellectual_list3')
            ])
            
            addSection('ENLACES', this.$t('legal_check.links_text1'))
            addText(this.$t('legal_check.links_text2'))
            addText(this.$t('legal_check.links_text3'))
            
            addSection('SEGURIDAD DE LA WEB', this.$t('legal_check.security_text1'))
            addText(this.$t('legal_check.security_text2'))
            
            addSection('MODIFICACIÓN UNILATERAL Y DURACIÓN', this.$t('legal_check.modification_text'))
            
            addSection('EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD', this.$t('legal_check.exclusion_intro'))
            addList([
                '• ' + this.$t('legal_check.exclusion_list1'),
                '• ' + this.$t('legal_check.exclusion_list2'),
                '• ' + this.$t('legal_check.exclusion_list3')
            ])
            
            addSection('TRATAMIENTO DE DATOS PERSONALES', this.$t('legal_check.data_text'))
            
            addSection('LEGISLACIÓN APLICABLE Y JURISDICCIÓN', this.$t('legal_check.jurisdiction_text'))
            
            addSection('CONTACTO', this.$t('legal_check.contact_text').replace("&#64;", "@"))
            
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(8)
            doc.setFont('helvetica', 'italic')
            doc.text('Aviso Legal actualizado a ' + fullDate, 15, y)
            y += 5
            doc.text('UNIT SEGUROS MEDIACION, S.L. - Todos los derechos reservados.', 15, y)
            
            doc.save('Aviso_Legal_Unit_Seguros.pdf')
        }
    }
}
</script>

<style scoped>
.legal-check-page {
    background: #f8fafc;
    padding: 60px 0;
    min-height: 70vh;
}

.legal-check-container {
    max-width: 900px;
    margin: 0 auto;
    background: white;
    padding: 50px;
    border-radius: 16px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

/* Título */
.legal-header-main {
    text-align: center;
    margin-bottom: 20px;
}

.legal-header-main h1 {
    color: #1C4A8D;
    font-size: 2.2rem;
    margin-bottom: 5px;
}

.legal-subtitle {
    color: #6c757d;
    font-size: 1rem;
}

/* Barra de progreso */
.scroll-progress {
    height: 4px;
    background: #e9ecef;
    border-radius: 2px;
    margin-bottom: 15px;
    overflow: hidden;
}

.scroll-progress-bar {
    height: 100%;
    background: #1C4A8D;
    transition: width 0.1s ease;
    border-radius: 2px;
}

/* Contenido scrollable */
.legal-content {
    line-height: 1.6;
    color: #4a5568;
    /* max-height: 600px; ← Eliminar o comentar */
    overflow-y: visible;  /* ← Cambiar de auto a visible */
    padding-right: 10px;
}

.legal-content::-webkit-scrollbar {
    width: 6px;
}

.legal-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.legal-content::-webkit-scrollbar-thumb {
    background: #1C4A8D;
    border-radius: 10px;
}

/* Paneles */
.legal-panel {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
    transition: box-shadow 0.2s;
}

.legal-panel:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.legal-panel-warning {
    border-left: 4px solid #F04B00;
}

.legal-panel-header {
    background: #f8f9fa;
    padding: 14px 22px;
    border-bottom: 1px solid #e9ecef;
}

.legal-panel-header h2 {
    color: #1C4A8D;
    font-size: 1.05rem;
    margin: 0;
    font-weight: 700;
}

.legal-panel-body {
    padding: 18px 22px;
}

.legal-panel-body p {
    margin-bottom: 8px;
}

.text-justify {
    text-align: justify;
}

/* Listas */
.legal-list {
    list-style: none;
    padding: 0;
    margin: 5px 0;
}

.legal-list li {
    padding: 4px 0;
    color: #4a5568;
    font-size: 0.92rem;
    line-height: 1.6;
}

.legal-list-label {
    font-weight: 600;
    color: #333;
}

.legal-list-value {
    color: #4a5568;
}

/* Aceptación */
.acceptance-section {
    margin-top: 20px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 10px;
    border-left: 4px solid #1C4A8D;
}

.acceptance-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    cursor: pointer;
    font-size: 0.95rem;
    color: #333;
    line-height: 1.5;
}

.acceptance-checkbox input[type="checkbox"] {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-top: 2px;
    accent-color: #1C4A8D;
    cursor: pointer;
}

.acceptance-error {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
    padding: 10px 15px;
    background: #fce8e6;
    color: #d93025;
    border-radius: 6px;
    font-size: 0.85rem;
}

/* Botones */
.legal-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px;
    padding-top: 20px;
    border-top: 2px solid #e9ecef;
    flex-wrap: wrap;
    gap: 15px;
}

.btn-group {
    display: flex;
    gap: 12px;
}

.btn {
    padding: 12px 30px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s;
    border: none;
    font-size: 0.95rem;
}

.btn-outline {
    background: transparent;
    color: #1C4A8D;
    border: 2px solid #1C4A8D;
    text-decoration: none;
}

.btn-outline:hover {
    background: #1C4A8D;
    color: white;
}

.btn-primary {
    background: #1C4A8D;
    color: white;
}

.btn-primary:hover:not(:disabled) {
    background: #143A6E;
}

.btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background: #5a6268;
}

/* Responsive */
@media (max-width: 768px) {
    .legal-check-container {
        padding: 25px;
    }
    .legal-header-main h1 {
        font-size: 1.6rem;
    }
    .legal-actions {
        flex-direction: column;
        align-items: stretch;
    }
    .btn-group {
        flex-direction: column;
    }
    .legal-actions .btn {
        width: 100%;
        justify-content: center;
    }
}
</style>